import { render, staticRenderFns } from "./pjnoticeForm.vue?vue&type=template&id=1c106ffb&scoped=true"
import script from "./pjnoticeForm.vue?vue&type=script&lang=js"
export * from "./pjnoticeForm.vue?vue&type=script&lang=js"
import style0 from "./pjnoticeForm.vue?vue&type=style&index=0&id=1c106ffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c106ffb",
  null
  
)

export default component.exports